import React  , { Component } from 'react'

import {  HomeSlider,
          HomeTitle,
          Img,
          CoverSection,
          ResponsiveYouTubeIframe    } from '../../Components/UI/UI'

import { getWeather, asyncgetWeather, isMobile } from "../../Utility/Utility";

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "./CoronaVirus.css"

class CoronaVirus extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}
  
  render(){
    return(
      <div className="page align-left page-Corona-virus">
        <Menu />
          <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
          <div className="ac-container">
      
       <h2 className="ac-pink"> Дорогие друзья,</h2>
      <p>В связи с решением правительства Израиля, принятом в рамках мер по сдерживанию распространения нового южноафриканского штамма «Омикрон», в течение следующих двух недель будет запрещен въезд для всех туристов. Разрешения, выданные на въезд с 29.11.2021, аннулируются. До последующего уведомления запросы на въезд туристов приниматься не будут.</p>
      
      <p>О дальнейших изменениях в правилах въезда будет сообщено дополнительно.</p>
      <p>Больше информации:  -  <a href="https://www.gov.il/he/departments/news/border_closing_coronavirus_14062020" rel="noopener" target="_blank">https://www.gov.il/he/departments/news/border_closing_coronavirus_14062020</a></p>
     
      </div>
  {/*  {!isMobile() ? (
          <CoverSection
            desktopImg={'/HomeSlider/corona.jpg'}
            mobileImg={'/HomeSlider/M/uk/4.jpg'}
            cssClass={'north'}
            waterTemp={this.state.waterTemp}
            telAvivWeather={this.state.telAvivWeather}
            jerusalemWeather={this.state.jerusalemWeather}
          />
        ) : (
          <div className="ac-corona-mobile-video">
            <ResponsiveYouTubeIframe vidId={'yE5MV_10cZw'} />
          </div>
        )}
            
          <div className="container">
             
             <div className="ac-new-container">
             <div className="ac-new-container">
 <h2 className="ac-pink"></h2>
 <h2 className="ac-pink ac-pink ac-margin-top-1 ac-bigger">Добро пожаловать, рады видеть вас снова!</h2>
<br/>
 С 1 декабря 2021 года въезд в Израиль разрешен для полностью вакцинированных Спутником V иностранных граждан

 <h2 className="ac-pink">Памятка российскому туристу для въезда в Израиль:</h2><br/>
 <ul>
    <li>1) Условия въезда:
      <ul>
        <li>- После получения двух доз вакцины, одобренной ВОЗ или «Спутника V», должно пройти не менее 14 дней со дня въезда, но не более 180 дней со дня выезда из Израиля. Или прошло более 14 дней после получения третьей бустерной дозы.</li>
        <li>- В аэропорту прибытия туристов ждет дополнительный ПЦР-тест и серологическое исследование (процедуры платные).</li>
        <li>- Перед вылетом за 24 часа нужно заполнить онлайн-форму (загрузить ПЦР-тест, сделанный за 72 часа до вылета и сертификат о вакцинации) и получить предварительное разрешение на въезд.</li>
        <li>- Страховка, покрывающая лечение COVID-19.</li>
        <li>- Турист не должен находиться в «красной» стране (по критериям Министерства здравоохранения Израиля) в течение последних 14 дней.</li>
      </ul>
      
</li>
<br/>
    <li>2) Карантин:<br/>
Туристы должны находиться в карантине в месте проживания 24 часа или до получения результатов отрицательного ПЦР-теста и положительного серологического анализа (как правило, приходит в течение нескольких часов). После получения положительного серологического анализа, турист сможет получить «зеленый пропуск» для посещения достопримечательностей и других общественных мест.
Продолжительность полного карантина - 14 дней (если антитела не обнаружены). Карантин может быть сокращен до 7 дней при соблюдении условий и рекомендаций.
</li>
<br/>
    <li>3) В случае обнаружения у туриста COVID-19:<br/>
Если во время путешествия в Израиле у туриста обнаружен COVID-19, его направят в специальный отель, который отдыхающий оплачивает самостоятельно или за счет страховки. 
</li>
<br/>
    <li>4) Действующие правила посещения общественных мест:
      <ul>
        <li>- Обязательное ношение масок в закрытых помещениях, а также на улице, если там находится более 100 человек.</li>
        <li>- Соблюдении социальной дистанции 1,5–2 метра</li>
        <li>- Наличие «зеленого пропуска» у лиц, старше 3-х лет</li>
      </ul>

</li>
 </ul>
 &nbsp;

 <br/>
 <p className="ac-align-center">Для получения полной информации на русском языке перейдите на сайт Министерства здравоохранения:<br/>
 <a href="https://corona.health.gov.il/directives/air-travel-covid19-green/?tab=by-air" target="_blank" rel="noopener" className="ac-align-center">https://corona.health.gov.il/directives/air-travel-covid19-green/?tab=by-air</a></p><br/>
 
 </div>
 
 <div className="ac-inner-video">
   <ResponsiveYouTubeIframe vidId={'LSb4Lmuw_Kw'}/>
 </div>
 </div>
 
           </div>
 
        */}
           
         <Footer />
       </div>
    )

  }

}



export default CoronaVirus


// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirus.js